//----------------------------------------------------------
// Global JS file
//----------------------------------------------------------


//
// Import
//

// LazyLoad
import loadLazyLoading from '../component/lazy-loading/lazy-loading';

// Tooltips
import loadTooltips from 'integration-common-files/src/js/01-atoms/tooltips';

// Dropdown
import DropdownList from 'integration-common-files/src/js/01-atoms/dropdown/DropdownList';
import DropdownSelect from 'integration-common-files/src/js/01-atoms/dropdown/DropdownSelect';

// Button group
import loadBtnGroup from 'integration-common-files/src/js/02-molecules/btn-group';

// Modal
import Modals from 'integration-common-files/src/js/03-organisms/modal';

// Marquee main cards
import loadMarqueeMainCards from '../component/marquee/marquee-main-cards';

// Marquee we caompare
import loadMarqueeWeCompare from '../component/marquee/marquee-we-compare';

// Process steps carousel
import loadProccessStepsCarousel from '../component/process-steps/process-steps';

// Satisfied customers carousel
import loadSatisfiedCustomersCarousel from '../component/satisfied-customers/satisfied-customers';

// Hook
import loadHooks from '../component/hook/hook';

// Perf
import loadPerf from '../component/performance/page-load';

import loadFonts from '../component/performance/fonts-load';

// SVG sprite
import loadSprite from '../component/sprite/sprite';

// Sort cards
import loadSortCards from '../component/sort-cards/sort-cards';

// CallBack
import loadCallBack from '../component/callback/callback';


//
// Load
//

window.addEventListener('load', () => {
  loadLazyLoading();
  loadMarqueeMainCards();
  loadMarqueeWeCompare();
  loadProccessStepsCarousel();
  loadSatisfiedCustomersCarousel();
  loadBtnGroup();
  loadHooks();
  loadTooltips();
  loadPerf();
  loadSprite();
  loadFonts();
  loadSortCards();
  loadCallBack();

  new DropdownList();
  new DropdownSelect();
  new Modals();
})

